module.exports = __webpack_public_path__ + "resources/img/equipment_tab2_img2.4449f219783fb0563979523f443771a4.jpg";